import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import CustomerForm from '../components/CustomerForm.jsx';
import ChainEntryForm from '../components/ChainEntryForm.jsx';

// Map a fuel-POS string from the billing report ('ESSO', 'BULLOCH',
// 'SUNCOR', 'PASSPORT') to Command's pos_type enum
// ('Bulloch'/'Bulloch Esso'/'Bulloch PetroCan'/'Passport').
function mapBillingPosToCommandPos(p) {
  const v = String(p || '').toUpperCase();
  if (v === 'ESSO')                                            return 'Bulloch Esso';
  if (v === 'SUNCOR' || v === 'PETROCANADA' || v === 'PETROCAN') return 'Bulloch PetroCan';
  if (v === 'PASSPORT')                                        return 'Passport';
  if (v === 'BULLOCH')                                         return 'Bulloch';
  return '';
}

function mapBillingPosToFuelBrand(p) {
  const v = String(p || '').toUpperCase();
  if (v === 'ESSO')   return 'Esso';
  if (v === 'SUNCOR') return 'Petro Canada';
  return '';
}

export default function CustomerNew() {
  const navigate = useNavigate();
  const [chainMode, setChainMode] = useState(false);
  const [searchParams] = useSearchParams();

  // Prefill from URL params — populated when the user lands here from
  // the Billing Diff page's '+ Add to Command' button.
  //
  // Field mapping (Dave 2026-06-07):
  //   billing 'site_name'  -> company   (for these onboarding rows the
  //                                      site IS the customer; e.g.
  //                                      "AB Centex 16 Ave (CEN00121)")
  //   billing 'client_id'  -> NOT a customer field. It's the xsite.io
  //                           username/password value used on the site
  //                           row Mary creates afterwards. Not surfaced
  //                           here — she'll either click the SiteForm
  //                           Generate button or paste the client_id in.
  //   site_number / city / province / address / phone / email / pos /
  //   customer_since        -> direct field map; missing fields fall
  //                            through to CustomerForm's defaults.
  const initial = {
    company:            searchParams.get('site_name')        || '',
    site_name:          searchParams.get('site_name')        || '',
    site_number:        searchParams.get('site_number')      || '',
    city:               searchParams.get('city')             || '',
    province_state:     searchParams.get('province_state')   || '',
    address1:           searchParams.get('address')          || '',
    phone_main:         searchParams.get('phone')            || '',
    email1:             searchParams.get('email')            || '',
    pos_type:           mapBillingPosToCommandPos(searchParams.get('pos')),
    fuel_brand:         mapBillingPosToFuelBrand(searchParams.get('pos')),
    first_contact_date: searchParams.get('customer_since')   || ''
  };

  async function handleSubmit(form) {
    await axios.post('/api/customers', form);
    navigate('/customers');
  }

  return (
    <section className="page">
      <div className="page-header">
        <h2>Add New Customer</h2>
        <Link to="/customers" className="btn-secondary">← Back to Customers</Link>
      </div>

      <div className="chain-toggle">
        <span className="chain-toggle-label">Part of existing chain?</span>
        <div className="chain-toggle-segmented">
          <button
            type="button"
            className={`chain-toggle-option${!chainMode ? ' chain-toggle-active' : ''}`}
            onClick={() => setChainMode(false)}
          >
            No · New company
          </button>
          <button
            type="button"
            className={`chain-toggle-option${chainMode ? ' chain-toggle-active' : ''}`}
            onClick={() => setChainMode(true)}
          >
            Yes · Pick existing chain
          </button>
        </div>
      </div>

      {chainMode ? (
        <ChainEntryForm
          recordType="customer"
          onSubmit={handleSubmit}
          submitLabel="Create Customer"
          onCancel={() => navigate('/customers')}
        />
      ) : (
        <CustomerForm
          compact
          initial={initial}
          onSubmit={handleSubmit}
          submitLabel="Create Customer"
          onCancel={() => navigate('/customers')}
        />
      )}
    </section>
  );
}
